import React, { useCallback } from "react";
import { Form, Image } from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { TiptapEditor } from "../../../TiptapEditor/TiptapEditor";
import { useFormik } from "formik";
import { Post } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./PostForm.form";
import "./PostForm.scss";

const postController = new Post();

export function PostForm(props) {
  const { accessToken } = useAuth();
  const { onClose, onReload, post } = props;

  const formik = useFormik({
    initialValues: initialValues(post),
    validationSchema: validationSchema(),
    validateOnChange: false,

    onSubmit: async (formValue) => {
      //console.log(formValue);
      // console.log(post);
      try {
        if (post) {
          await postController.updatePost(accessToken, post._id, formValue);
        } else {
          await postController.createPost(accessToken, formValue);
        }

        onReload();
        onClose();
      } catch (error) {
        console.log(error);
      }
    },
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file.type === "image/jpeg" || file.type === "image/png") {
        formik.setFieldValue("miniature", URL.createObjectURL(file));
        formik.setFieldValue("file", file);
      } else {
        console.log("Tipo de archivo no soportado:", file.type);
      }
    },
    [formik],
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    noKeyboard: true,
    onDrop,
  });

  const getMiniature = () => {
    if (formik.values.file) {
      return formik.values.miniature;
    } else if (formik.values.miniature) {
      return `${formik.values.miniature}`;
    }
    return null;
  };
  // console.log(`Miniature path: ${formik.values.miniature}`);

  return (
    <div>
      <Form className="post-form" onSubmit={formik.handleSubmit}>
        <Form.Group widths="equal">
          <Form.Input
            name="title"
            placeholder="Titulo del post"
            onChange={formik.handleChange}
            value={formik.values.title}
            error={formik.errors.title}
          />
          <Form.Input
            name="path"
            placeholder="url del post"
            onChange={formik.handleChange}
            value={formik.values.path}
            error={formik.errors.path}
          />
        </Form.Group>

        <TiptapEditor
          content={formik.values.content}
          onChange={(newContent) => formik.setFieldValue("content", newContent)}
        />

        <div className="post-form__miniature" {...getRootProps()}>
          <input {...getInputProps()} />
          {getMiniature() ? (
            <Image size="small" src={getMiniature()} />
          ) : (
            <div>
              <span> Arrastra tu imagen </span>
            </div>
          )}
        </div>

        <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
          {post ? "Actualizar post" : "Crear post"}
        </Form.Button>
      </Form>
    </div>
  );
}
